import React from 'react'
import { ComposedChart, XAxis, YAxis, Area, ResponsiveContainer, Legend, Line, LabelList, CartesianGrid } from 'recharts'

import Theme from '../../../../styles/_theme.module.scss'
import { useResultsContext } from '../context/context'

interface Props {
  data: object[]
  formatter?: (val: number) => string | number
  yAxisFormatter?: (val: number) => string | number
  maxYAxisvalue: number
  minYAxisvalue: number
  numberOfTicks: number
}

const ResultsComposedChart: React.FC<Props> = ({
  data,
  formatter,
  yAxisFormatter,
  maxYAxisvalue,
  minYAxisvalue,
  numberOfTicks,
}) => {

  const context = useResultsContext()

  return (
    <ResponsiveContainer width='100%' height='100%' debounce={1}>
      <ComposedChart
        data={data}
        margin={{
          top: 20,
          right: 50,
          bottom: 10
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis dataKey="name" padding={{ left: 75, right: 75}} tickLine={false} />
        <YAxis
          axisLine={false}
          tickLine={false}
          minTickGap={0}
          tickMargin={0}
          tickCount={numberOfTicks + 1}
          tickFormatter={yAxisFormatter ? (tick: any) => yAxisFormatter(tick) : formatter ? tick => formatter(tick) : tick => tick}
          domain={[minYAxisvalue, maxYAxisvalue]} />
        <Line dataKey='rate' stroke={Theme.blue} strokeWidth={3} name='Interest Rate' animationDuration={context.noAnimations ? 0 : 1000}>
          <LabelList
            dataKey='rate'
            position='top'
            offset={10}
            fontSize={12}
            fontWeight='bold'
            formatter={formatter ? (tick: any) => formatter(tick) : (tick: any) => tick} />
        </Line>
        <Line dataKey='midpoint' dot={false} strokeWidth={0} legendType='none' animationDuration={context.noAnimations ? 0 : 1000}>
          <LabelList
            dataKey='margin'
            position='top'
            fontSize={12}
            fontWeight='bold'
            formatter={formatter ? (tick: any) => formatter(tick) : (tick: any) => tick} />
        </Line>
        <Area dataKey='net' fill={Theme.lightGreen} stroke={Theme.lightGreen} fillOpacity={0.2} strokeWidth={0} legendType='square' name='Net Interest Margin' animationDuration={context.noAnimations ? 0 : 1000}/>
        <Line dataKey='cost' stroke={Theme.orange} strokeWidth={3} name='Cost of Funds' animationDuration={context.noAnimations ? 0 : 1000}>
          <LabelList
            dataKey='cost'
            position='top'
            offset={-18}
            fontSize={12}
            fontWeight='bold'
            formatter={formatter ? (tick: any) => formatter(tick) : (tick: any) => tick} />
        </Line>
        <Legend wrapperStyle={{ bottom: 10, left: 0, right: 0 }} />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default ResultsComposedChart